import downloadFile from "js-file-download";
import * as React from "react";
import { FaDownload } from "react-icons/fa";
import styled from "styled-components";

import { AddButton, ButtonRow, ErrorHeader } from "../../../../App/Common/Components/FormComponents";
import { SectionSubTitle } from "../../../../App/Common/Styles/containers";
import { ResultsContainer } from "./ImportReport.styles";
import { IImportReportStateProps } from "./ImportReport.types";

const ImportReportContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.lightgrey3};
  padding: 2rem 1rem;
  margin: 1rem 0;
`;

const ResultsWrapper = styled.div`
  display: flex;
  margin: auto 0;
`;

const ErrorMsg = styled.p`
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.yellow};
`;

const DownloadIcon = styled(FaDownload)`
  margin: 0 0.5rem;
`;

enum ValueType {
  Description,
  Failure,
  Success,
}

const Value = styled.span<{ type: ValueType }>`
  margin-left: 0.5em;
  font-weight: bold;
  color: ${({ theme, type }) => {
    switch (type) {
      case ValueType.Failure:
        return theme.colors.red;
      case ValueType.Success:
        return theme.colors.darkgreen;
      default:
        return theme.colors.darkblue;
    }
  }};
`;

const Right = styled.td`
  text-align: right;
`;

const Left = styled.td`
  text-align: left;
`;

const Stat: React.FC<{
  description: string;
  value: number;
  type?: ValueType;
}> = ({ description, value, type = ValueType.Description }) => (
  <tr>
    <Right>{description}</Right>
    <Left>
      <Value type={type}>{value}</Value>
    </Left>
  </tr>
);

export const ImportReportComponent: React.FC<IImportReportStateProps> = ({ report }) => {
  if (!report) {
    return null;
  }
  const download = () => {
    downloadFile(report.nextCsv, report.nextCsvName);
  };
  return (
    <>
      <ImportReportContainer>
        <SectionSubTitle>Upload Completed!</SectionSubTitle>
        <ResultsWrapper>
          <ResultsContainer>
            <table>
              <tbody>
                <Stat description="Unchanged translations:" value={report.numEqualValues} />
                <Stat description="Updated translations:" value={report.numUpdates} type={ValueType.Success} />
                <Stat description="Missing translations:" value={report.numMissing} type={ValueType.Failure} />
                <Stat description="Failed imports:" value={report.numFailures} type={ValueType.Failure} />
                <Stat description="Comitted patches:" value={report.numPatches} />
              </tbody>
            </table>
          </ResultsContainer>
        </ResultsWrapper>
        {report.parsingFailure && (
          <>
            <h4>
              <ErrorHeader>Parsing Failure: </ErrorHeader>
            </h4>
            <ErrorMsg>{report.parsingFailure}</ErrorMsg>
          </>
        )}
        <span>Download the updated CSV with its results file to process it further:</span>
      </ImportReportContainer>
      <ButtonRow width={22} margin={1}>
        <AddButton onClick={download}>
          <span>
            <DownloadIcon /> Download updated CSV file
          </span>
        </AddButton>
      </ButtonRow>
    </>
  );
};
